<soft-page>
  <soft-page-header>
    <soft-date-navigator [date]="viewedDate()" (dateChange)="dateChanged($event)" />
  </soft-page-header>

  @if (noteTypeSegments$ | async; as segments) {
    @if (segments && segments.length > 0) {
      <soft-input
        (valueChange)="onSearchInputChange($event ?? '')"
        class="mt-3"
        [placeholder]="
          (activeSegment$ | async) === 'MATERIAL'
            ? ('#DELIVERY_NOTE.OVERVIEW.SEARCH.PLACEHOLDER_MAT' | translate)
            : ('#DELIVERY_NOTE.OVERVIEW.SEARCH.PLACEHOLDER_LIEF' | translate)
        "
      />

      <soft-segmented-control
        [selected]="activeSegment$ | async"
        [segments]="segments"
        (segmentChange)="onChangeListType($event)"
      />
    }
  }

  <div class="flex flex-col mt-3">
    @if (loading$ | async) {
      <div class="div flex flex-row items-center w-full justify-center loading-wrapper">
        <soft-loading-spinner class="spin" />
      </div>
    } @else {
      @if (((noteTypeSegments$ | async)?.length ?? 0) > 0) {
        <!-- Lieferscheine -->
        @if ((activeSegment$ | async) !== 'MATERIAL') {
          <div class="flex flex-col w-full gap-2">
            @if (filteredNotes$ | async; as filteredNotes) {
              @if (filteredNotes.length < 1) {
                <div class="placeholder-wrapper">
                  <span class="color-light">
                    {{ '#DELIVERY_NOTE.OVERVIEW.EMPTY.LIEFERSCHEINE' | translate }}
                  </span>
                </div>
              } @else {
                @for (
                  deliveryNote of filteredNotes | sort: 'lieferzeit' : 'ASC';
                  track deliveryNote.id
                ) {
                  <soft-delivery-note-card
                    (click)="showDetails(deliveryNote.id)"
                    [deliveryNote]="deliveryNote"
                  />
                }
              }
            }
          </div>
        }

        <!-- Materialscheine -->
        @if ((activeSegment$ | async) === 'MATERIAL') {
          <div class="flex flex-col w-full gap-2">
            @if (filteredNotes$ | async; as filteredNotes) {
              @if (filteredNotes.length < 1) {
                <div class="placeholder-wrapper">
                  <span class="color-light">
                    {{ '#DELIVERY_NOTE.OVERVIEW.EMPTY.MATERIALSCHEINE' | translate }}
                  </span>
                </div>
              } @else {
                @for (
                  deliveryNote of filteredNotes | sort: 'lieferzeit' : 'ASC';
                  track deliveryNote.id
                ) {
                  <soft-delivery-note-card
                    (click)="showDetails(deliveryNote.id)"
                    [deliveryNote]="deliveryNote"
                  />
                }
              }
            }
          </div>
        }
      } @else {
        <div class="flex flex-row">
          <div
            class="placeholder-wrapper flex w-full text-center items-center justify-center"
          >
            <span class="color-light">
              {{ '#DELIVERY_NOTE.OVERVIEW.EMPTY.NO_DATA' | translate }}
            </span>
          </div>
        </div>
      }
    }
  </div>
</soft-page>

<ng-template #menuBar>
  <soft-menu-bar-button
    [variant]="'outline'"
    [icon]="'fa-regular fa-barcode-read'"
    [responsive]="true"
    [label]="'Suche'"
    tooltip="Lieferschein suchen"
    (execute)="openScanDialog()"
  />
</ng-template>
